import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
// @ts-ignore
import { Dialog } from '@netbasequid/core'
// @ts-ignore
import { sys } from '@netbasequid/theme'
import { Theme } from 'features/ui/types'
import { useDisplayTheme } from 'hooks/useUiState'

const StyledLink = styled.a`
  color: ${({ mode }: { mode: Theme }) => sys[mode].interaction.primary.default};
`

interface ErrorDialogProps {
  showError: boolean
  setShowError: React.Dispatch<React.SetStateAction<boolean>>
}

const ErrorDialog = ({ showError, setShowError }: ErrorDialogProps) => {
  const theme = useDisplayTheme() as Theme
  const { t } = useTranslation()

  return (
    <Dialog
      mode={theme}
      open={showError}
      width="600px"
      onClose={() => {
        setShowError(false)
      }}>
      <Dialog.DialogTitle>{t('cannotDownloadPdfTitle')}</Dialog.DialogTitle>
      <Dialog.DialogContent height="100px">
        {t('cannotDownloadPdfMessagePrefix')}
        <StyledLink href="mailto:support@quid.com" mode={theme}>
          Quid Support
        </StyledLink>
        {t('cannotDownloadPdfMessageSuffix')}
      </Dialog.DialogContent>
      <Dialog.DialogActions />
    </Dialog>
  )
}

export default ErrorDialog
